// libraries
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { apiDocumentsPortal } from '@store/apiSlices/apiSlices';

// interfaces
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { UpdateOrchestratorTaskStatusRequest } from '../../interfaces/interfaces';

interface UpdateOrchestratorTaskStatusResponse {
  message: string;
  success: boolean;
}

export const orchestratorTaskStatusApi = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    updateOrchestratorTaskStatus: builder.mutation<
      UpdateOrchestratorTaskStatusResponse,
      UpdateOrchestratorTaskStatusRequest
    >({
      query: body => ({
        url: '/update_orchestrator_task_status',
        method: 'PATCH',
        body,
      }),
      transformErrorResponse: (error: FetchBaseQueryError): ModelError => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'updateOrchestratorTaskStatus',
        };
        return modelError;
      },
      transformResponse: (response: UpdateOrchestratorTaskStatusResponse) => {
        return response;
      },
    }),
  }),
});

export const { useUpdateOrchestratorTaskStatusMutation } = orchestratorTaskStatusApi;
